/**
 * MyEasyGov Platform API
 * MyEasyGov Platform API.  MyEasyGov's web and mobile app communicates with the MEG platform via this API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from "./address";
import { Donation } from "./donation";
import { NotificationOptions } from "./notificationOptions";
import { RenewalItem } from "./renewalItem";

/**
 * this describes a renewal request, which is comprised of one or more renewal items.
 */
export interface Renewal {
	/**
     * this field will be omitted for the initial posting of the working renewal.  On subseuquent postings (i.e. updates), this field will be provided.
     */
	renewalToken?: string;
	renewalItems?: Array<RenewalItem>;
	/**
     * this field will be omittted if customer did not make any donations.
     */
	donations?: Array<Donation>;
	/**
     * 2-decimal places
     */
	megAppFee?: number;
	/**
     * this is the provider's fee calculated and accepted by the consumer.  If provider cannot honor this fee amount, the request should be rejected with an appropriate outcome code.
     */
	serviceProviderFee?: number;
	/**
     * if the delivery method is MX (mail to differnt address), request will include a MailToAddress field; otherwise, it won't.
     */
	deliveryMethod?: Renewal.DeliveryMethodEnum;
	/**
     * pickup location
     */
	pickupLocationID?: string;
	/**
     * name of the person who will be picking up the renewal
     */
	pickupPersonName?: string;
	pickupEmailAddress?: string;
	pickupPhoneNumber?: string;
	mailToName?: string;
	mailToAddress?: Address;
	updateAddressOnFile?: boolean;
	/**
     * token (issued by the service provider) for a payment device.  On the service provider's platform, the token maps to account data about the payment device, name, address, phone and email address.
     */
	fundingToken?: string;
	notificationOptions?: NotificationOptions;
	comment?: string;
	webComponentLoadTime?: number;
}
export namespace Renewal {
	export type DeliveryMethodEnum = "MF" | "MX" | "PU";
	export const DeliveryMethodEnum = {
		MF: "MF" as DeliveryMethodEnum,
		MX: "MX" as DeliveryMethodEnum,
		PU: "PU" as DeliveryMethodEnum
	};
}
